import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';

@inject('Game4Store')
@observer
export default class Game4Step3 extends Component {

    componentDidMount() {
        if (this.props.Game4Store.levels.length === 0) {
            this.props.Game4Store.loadQuestions();
        }
    }

    onChangeClassLevel = (indexLevelSelected) => {
        this.props.Game4Store.setMaxLevel(indexLevelSelected);
    };

    render() {

        const {
            levelList,
            maxLevel
        } = this.props.Game4Store;

        const levels = levelList.map(
            (level, index) => (
                <div
                    key={index}
                    className={"btn-select-level " + (index === maxLevel ? "selected" : "")}
                    onClick={() => this.onChangeClassLevel(index)}>{level}</div>
            )
        );

        return (
            <div className="step-3">
                <h1>Highest Level in class</h1>
                <div className="levels">
                    {levels}
                </div>
            </div>
        )
    }

};


// WEBPACK FOOTER //
// ./src/containers/Game4/Game4Step3.js